var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{ref:"textarea",class:_vm.classes,attrs:{"disabled":_vm.disabled,"id":_vm.id,"cols":_vm.cols,"rows":_vm.rows}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }